import React, { useState } from 'react';

import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import { MenuItem } from '@material-ui/core';
import { compose } from 'recompose';
import { withRouter } from 'react-router-dom';
import UserAvatar from 'components/UserAvatar';
import { ROUTE_ACCOUNT, ROUTE_HOME } from 'routes/routes';
import { useFirebase } from 'components/Firebase/context';

const UserMenu = ({ authUser, history }) => {
  const firebase = useFirebase();
  const [anchor, setAnchor] = useState(null);
  const open = Boolean(anchor);
  const signOut = () => {
    firebase.doUserLogOut();
    history.push(ROUTE_HOME);
  };
  return (
    <div>
      <IconButton
        aria-owns={open ? 'menu-appbar' : undefined}
        aria-haspopup="true"
        onClick={e => setAnchor(e.target)}
        color="inherit"
      >
        <UserAvatar authUser={authUser} />
      </IconButton>
      <Menu
        id="menu-appbar"
        anchorEl={anchor}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        open={open}
        onClose={() => setAnchor(null)}
      >
        <MenuItem onClick={() => history.push(ROUTE_ACCOUNT)}>My Account</MenuItem>
        <MenuItem onClick={signOut}>Sign Out</MenuItem>
      </Menu>
    </div>
  );
};

export default compose(withRouter)(UserMenu);
